// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2vhwg","rightAdornment":"Header_rightAdornment__2m0Wa"};